module.exports = __webpack_public_path__ + "img/广州办公室 (2).3b15a2ac.jpg";